<template>
  <div>
    <el-form-item :label="$t('限定范围')">
      <l-select v-model="data.limits" :options="optionsLimits" />
    </el-form-item>
    <template v-if="data.limits == '4'">
      <el-form-item :label="$t('公司选择')">
        <l-company-select v-model="data.companyId" />
      </el-form-item>
      <el-form-item :label="$t('部门选择')">
        <l-department-select :companyId="data.companyId"  v-model="data.departmentId"/>
      </el-form-item>
    </template>
    <el-form-item :label="$t('是否多选')">
      <el-switch v-model="data.multiple"></el-switch>
    </el-form-item>
    <el-form-item :label="$t('登录者')">
      <el-switch v-model="data.isLogin"></el-switch>
    </el-form-item>
    <el-form-item :label="$t('是否必填')">
      <el-switch v-model="data.required"></el-switch>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "config-userSelect",
  props: ["data"],
  data() {
    return {
      optionsLimits: [
        { value: "1", label: "无限制" },
        { value: "2", label: "登录者公司" },
        { value: "3", label: "登录者部门" },
        { value: "4", label: "自定义" },
      ],
    };
  },
  methods: {},
};
</script>
